import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { PostHogConfig } from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import { GlobalStylesOverride } from '@/modules/layouts/GlobalStylesOverride.tsx'
import theme from '@/modules/layouts/theme.tsx'
import { LanguageProvider } from '@/system/i18n/LanguageProvider.tsx'
import { router } from '@/system/router/index.tsx'

// eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
const options: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  autocapture: true,
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider
      options={options}
      apiKey={import.meta.env.VITE_POSTHOG_KEY}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStylesOverride />
        <LanguageProvider>
          <RouterProvider router={router} />
        </LanguageProvider>
      </ThemeProvider>
    </PostHogProvider>
  </React.StrictMode>
)
